<template>
    <div>

        <img src="/img/logo_icon.svg" style="height: 35px;" class="mb-4" />

        <div v-if="loading" class="text-center"><img src="/loading.svg" /><p>Loading...</p></div>
        <div v-else>
            <div v-if="displayFinish" class="text-center">
                <h1 class="my-4">You did it!</h1>
                <img src="/img/celebration.gif" style="border-radius: 2rem; margin-bottom: 1.5em;" />
                <p>Your portal started it's life on:<br /><span class="text-primary">{{portal_url}}</span></p>
                <p class="text-left mx-auto p-3" style="max-width: 500px; border-radius: 16px; background-color: #f2f4f7;">
                    ✍️  Remember the portal URL. You can only log in here.<br />
                    ✉️  You got an email with the account details and portal URL.
                </p>
                <a class="btn btn-primary mt-3" :href="hash_login_url">Continue <i class="fa fa-arrow-right"></i></a>
            </div>

            <div v-if="displayNewLicenseCode">
                <h1 class="my-4">We combined your licenses into 1 code</h1>
                <p>This is your new code. Make sure to copy it safe. You can create new projects/portals <b>only with this code</b>.</p>
                <p class="text-left mx-auto p-3" style="max-width: 500px; border-radius: 16px; background-color: #f2f4f7;">
                    {{newLicenseCode}}
                </p>
                <p>Please copy this code. For next projects, enter only this code and choose to redeem 1 AppSumo code.</p>
                <b-button variant="primary" class="mt-3" @click="gotoFinish()">Next <i class="fa fa-arrow-right"></i></b-button>
            </div>


            <div v-if="isFormOpen">

                <div v-if="licenses.length === 0">
                    <h1 class="mt-0 mb-3">Welcome to ProductLift</h1>

                    <p class="mb-5">ProductLift enables quick and efficient feedback collection to effortlessly shape your product roadmap.</p>

                    <p>Hi sumoling 👋 Let's create your account.</p>

                    <p>How many {{license_code_name}}s did you purchase?</p>
                    <b-button variant="outline" @click="setNumberLicenses(1)">1</b-button>
                    <b-button variant="outline" @click="setNumberLicenses(2)">2</b-button>
                    <b-button variant="outline" @click="setNumberLicenses(3)">3</b-button>
                    <b-button variant="outline" @click="setNumberLicenses(4)">4</b-button>
                    <b-button variant="outline" @click="setNumberLicenses(5)">5</b-button>
                    <p class="mt-2 text-muted">Choose 1 if you stacked multiple codes earlier.</p>
                </div>
                <div v-else>

                    <validation-observer ref="observer" v-slot="{ passes }">
                        <form @submit.stop.prevent="passes(signup)">
                            <p class="mt-3 mb-1">{{license_code_name}}(s)</p>
                            <b-alert show variant="danger" v-if="license_error">{{license_error}}</b-alert>
                            <template v-for="license in licenses">
                                <validation-provider :name="license_code_name" rules="required|license_code" v-slot="{ errors }">
                                    <b-form-input class="mt-1" type="text" v-model="license.key" placeholder="license_3726cf2c..."></b-form-input>
                                    <span class="validation">{{ errors[0] }}</span>
                                </validation-provider>
                            </template>


                            <p class="mt-3 mb-1">Product name</p>
                            <validation-provider name="name" rules="min:3|required" v-slot="{ errors }">
                                <b-form-input v-model="name" placeholder="Your product"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <p class="mt-3 mb-1">Portal URL</p>
                            <validation-provider name="domain" rules="subdomain|required" v-slot="{ errors }">
                                <b-input-group append=".productlift.dev">
                                    <b-form-input v-model="domain" placeholder="my-product"></b-form-input>
                                </b-input-group>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                            <small class="text-muted">Start with a .productlift.dev domain, switch to custom after signup.</small>

                            <p class="mt-3 mb-1">Language</p>
                            <validation-provider name="language" rules="required" v-slot="{ errors }">
                                <b-form-select v-model="language" :options="language_options"></b-form-select>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                            <small class="text-muted">Language missing? Tell us post-signup—we’ll add it!</small>

                            <p class="mt-3 mb-1">Email</p>
                            <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                                <b-form-input type="email" autocomplete="email" v-model="email" placeholder="Enter your email"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <p class="mt-3 mb-1">Password</p>
                            <validation-provider name="password" rules="required" v-slot="{ errors }">
                                <b-form-input type="password" autocomplete="new-password" v-model="password" placeholder="••••••••••"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>

                            <p class="text-muted">By signing up you agree with the <a href="https://www.productlift.dev/legal" target="_blank" style="color: #000000; text-decoration: underline;">Terms</a>.</p>
<!--                            <validation-provider name="terms" rules="required" v-slot="{ errors }">-->
<!--                                <b-form-checkbox class="mt-5" v-model="checkbox" value="accepted" :unchecked-value="null">I agree with the <a href="https://www.productlift.dev/legal/privacy-policy" target="_blank">Privacy</a>, <a href="https://www.productlift.dev/legal/data-processing-agreement" target="_blank">DPA</a>, <a href="https://www.productlift.dev/legal/end-user-license-agreement" target="_blank">EULA</a>, and <a href="https://www.productlift.dev/legal/terms" target="_blank">Terms</a>.</b-form-checkbox>-->
<!--                                <span class="validation">{{ errors[0] }}</span>-->
<!--                            </validation-provider>-->

                            <button type="submit" class="btn btn-primary btn-block mt-3">Sign up</button>
                            <p class="small">Already have an account? <a href="https://app.productlift.dev/find_portal">Login to your account</a></p>
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationPop from '../mixins/NotificationPop.js'

export default {
    name: "SignupAppsumo",
    mixins: [NotificationPop],
    components: {
    },

    data() {
        return {
            loading: true,
            isFormOpen: true,
            progress: 20,
            language_options: [],
            license_code_name: 'AppSumo Code',
            license_error: null,
            hash_login_url: null,
            portal_url: null,
            displayNewLicenseCode: false,
            newLicenseCode: null,
            displayFinish: false,


            licenses: [],
            email: null,
            language: null,
            password: null,
            checkbox: null,
            domain: null,
            name: null,
        }
    },

    async created() {

        this.$http.get('/api/available_languages')
            .then(({data}) => {
                this.loading = false;
                this.language_options = data
            })
            .catch(error => {
                this.loading = false;
                this.popNotification('Something went wrong on our side. Could not load buttons. Please try again or contact support@productlift.dev', 'danger')
            });
    },
    methods: {
        /**
         * Set number of expected licenses
         * @param number
         */
        setNumberLicenses: function (number) {
            for (let i = 0; i < number; i++) {
                this.licenses.push({type: 'add'});
            }
        },

        /**
         * Show finish
         */
        gotoFinish: function () {
            this.displayFinish = true
            this.displayNewLicenseCode = false

            this.$confetti.start({
                particles: [
                    {
                        type: 'heart',
                        size: 14,
                    }
                ],
            });
            setTimeout(() => this.$confetti.stop(), 2000);
        },

        /**
         * Create the new portal
         */
        signup: function () {
            this.isFormOpen = false;
            this.loading = true;
            this.license_error = null; // reset

            this.$http.post('/api/signup',{
                licenses: this.licenses,
                name: this.name,
                domain: this.domain,
                language: this.language,
                email: this.email,
                password: this.password,
            })
                .then(({data}) => {
                    this.hash_login_url = data.hash_login_url
                    this.portal_url = data.portal_url
                    this.progress = 100
                    this.loading = false

                    if(data.new_license_code) {
                        this.displayNewLicenseCode = true
                        this.newLicenseCode = data.new_license_code
                    } else {
                        this.gotoFinish()
                    }
                    this.popNotification('Created', 'success')
                })
                .catch(error => {
                    this.isFormOpen = true;
                    this.loading = false

                    if(error.response.data.message === 'license_not_found') {
                        this.license_error = 'Sorry, we are not able to redeem this license: ' + error.response.data.key + '. Try again or contact support.';
                    }
                    // handle authentication and validation errors here
                    console.log(error.response)
                    this.popNotification('Could not signup', 'danger')
                })
        },


    }
}
</script>